/* lua.js generated code 0.3.0 */

require("hecore/rpc")
require("clover/net/Http")
const Event = require("hecore/EventDispatcher").Event

var kUserLogin = true
GetStarRewardsHttp = xClass("GetStarRewardsHttp", HttpBase)
GetStarRewardsHttp.prototype.load = function (rewardId) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(rewardId) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endPoint, data, err) {
        if (err) {
            he_log_info("get reward fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("get reward success")
            if (type(data) === "table" && type(data.rewardItems) === "table") {
                for (var k1 in data.rewardItems) {
                    var v1 = data.rewardItems[k1]
                    var itemId = v1.itemId
                    var itemNumber = v1.num
                    UserManager.getInstance().addUserPropNumber(itemId, itemNumber)
                    DcUtil.logRewardItem("star", itemId, itemNumber, -1)
                    if (NetworkConfig.writeLocalDataStorage) {
                        Localhost.getInstance().flushCurrentUserData()
                    } else {
                        cc.log("Did not write user data to the device.")
                    }
                }
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getStarRewards, table([1, "starRewardId", rewardId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// UnlockLevelAreaHttp ---------------------------------------------------------
UnlockLevelAreaHttp = xClass("UnlockLevelAreaHttp", HttpBase)
UnlockLevelAreaHttp.prototype.load = function (levelAreaId, unlockType) {
    var self = this
    cc.log("UnlockLevelAreaHttp:load", levelAreaId, unlockType)
    assert(unlockType != null, "unlockType must not a nil")
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("unLockLevelArea fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("unLockLevelArea success")
            context.onLoadingComplete(data)
        }
    }
    // if (unlockType === 1) {
    //     UserManager.getInstance().cacheHttp(kHttpEndPoints.unlockLevelArea, table([1, "type", unlockType], [1, "areaId", levelAreaId]))
    //     if (NetworkConfig.writeLocalDataStorage) {
    //         Localhost.getInstance().flushCurrentUserData()
    //     } else {
    //         cc.log("Did not write user data to the device.")
    //     }
    //     context.onLoadingComplete()
    // } else {
    self.request(kHttpEndPoints.unlockLevelArea, table([1, "type", unlockType], [1, "areaId", levelAreaId]), loadCallback, rpc.SendingPriority.kHigh, false)
    // }
}
// 1.5废弃
// MarkHttp ---------------------------------------------------------
MarkHttp = xClass("MarkHttp", HttpBase)
MarkHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("mark fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("mark success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.mark, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// MarkV2Http ---------------------------------------------------------
MarkV2Http = xClass("MarkV2Http", HttpBase)
MarkV2Http.prototype.load = function (data) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("mark fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("mark success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.markV2, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// LikeUserHttp ---------------------------------------------------------
LikeUserHttp = xClass("LikeUserHttp", HttpBase)
LikeUserHttp.prototype.load = function (uid, likeType) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("like fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("like success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.likeUser, table([1, "targetUid", uid], [1, "type", likeType]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// SellPropsHttp ---------------------------------------------------------
SellPropsHttp = xClass("SellPropsHttp", HttpBase)
SellPropsHttp.prototype.load = function (itemID, num) {
    var self = this
    assert(itemID != null, "itemID must not a nil")
    assert(num != null, "num must not a nil")
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("sellProps fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("sellProps success")
            context.onLoadingComplete()
            Localhost.sellProps(itemID, num)
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
        }
    }
    self.transponder.call(kHttpEndPoints.sellProps, table([1, "itemID", itemID], [1, "num", num]), loadCallback, rpc.SendingPriority.kHigh, false)
}

//ReplayHttp
ReplayHttp = xClass("ReplayHttp", HttpBase);
ReplayHttp.prototype.load = function (content) {
    var self = this
    function loadCallback(endpoint, data, err) {
        // body
        if (err) {
            self.onLoadingError(err)
        } else {
            self.onLoadingComplete(data)
        }
    }
    // cc.warn("writeReplay is ignore")
    self.onLoadingComplete(table())
    self.request(kHttpEndPoints.writeReplay, content, loadCallback, rpc.SendingPriority.kHigh, false)
}

BuyOnlineHttp = xClass("BuyOnlineHttp", HttpBase)
BuyOnlineHttp.prototype.load = function (goodsId, num, moneyType, targetId, time) {
    var self = this
    assert(goodsId != null, "goodsId type is int")
    assert(num != null, "num type is int")
    assert(moneyType != null, "moneyType type is int")
    assert(targetId != null, "targetId type is int")
    function loadCallback(endpoint, data, err) {
        // body
        if (err) {
            self.onLoadingError(err)
        } else {
            let ret_data = table(
                [1, "goodsId", goodsId],
                [1, "num", num],
                [1, "moneyType", moneyType],
                [1, "targetId", targetId],
                [1, "requestTime", Localhost.time()],
                [1, "buyResultInfo", data.buyResultInfo || ""]
            );
            self.onLoadingComplete(ret_data)
        }
    }

    let data = {
        "goodsId": goodsId,
        "num": num,
        "moneyType": moneyType,
        "targetId": targetId
    };
    if (time){
        data.requestTime = time
    }
    self.request(kHttpEndPoints.buy, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// BuyHttp ---------------------------------------------------------
BuyHttp = BuyOnlineHttp
// BuyHttp = xClass("BuyHttp", HttpBase)
// BuyHttp.prototype.load = function (goodsId, num, moneyType, targetId) {
//     var self = this
//     assert(goodsId != null, "goodsId type is int")
//     assert(num != null, "num type is int")
//     assert(moneyType != null, "moneyType type is int")
//     assert(targetId != null, "targetId type is int")
//     // UserManager.getInstance().cacheHttp(kHttpEndPoints.buy, table(
//     //     [1, "goodsId", goodsId],
//     //     [1, "num", num],
//     //     [1, "moneyType", moneyType],
//     //     [1, "targetId", targetId],
//     //     [1, "requestTime", Localhost.time()]
//     // ))
//     // if (NetworkConfig.writeLocalDataStorage) {
//     //     Localhost.getInstance().flushCurrentUserData()
//     // } else {
//     //     cc.log("Did not write user data to the device.1")
//     // }
//     let data = table(
//         [1, "goodsId", goodsId],
//         [1, "num", num],
//         [1, "moneyType", moneyType],
//         [1, "targetId", targetId],
//         [1, "requestTime", Localhost.time()]
//     );
//     self.onLoadingComplete(data)
// }
// BuyHttp ---------------------------------------------------------
// getInviteCountRewards ---------------------------------------------------------
GetInviteCountRewards = xClass("GetInviteCountRewards", HttpBase)
GetInviteCountRewards.prototype.load = function (countRewardId) {
    var self = this
    assert(type(countRewardId) === "number")
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get invite friends count reward error: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            he_log_info("get invite friends reward success !")
            context.onLoadingComplete()
        }
    }
    self.transponder.call(kHttpEndPoints.getInviteCountRewards, table([1, "countRewardId", countRewardId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetInviteFriendsReward ---------------------------------------------------------
GetInviteFriendsReward = xClass("GetInviteFriendsReward", HttpBase)
GetInviteFriendsReward.prototype.load = function (friendUids, rewardId) {
    var self = this
    assert(type(friendUids) === "table")
    assert(type(rewardId) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get invite friends reward error: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            he_log_info("get invite friends reward success !")
            context.onLoadingComplete()
        }
    }
    self.transponder.call(kHttpEndPoints.getInviteFriendsReward, table([1, "friendUids", friendUids], [1, "rewardId", rewardId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// UpdateProfileHttp
// 
UpdateProfileHttp = xClass("UpdateProfileHttp", HttpBase)
UpdateProfileHttp.prototype.load = function (name, headUrl, snsPlatform, snsName) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("UpdateProfileHttp err" + err)
            context.onLoadingError(err)
        } else {
            he_log_info("UpdateProfileHttp ok")
            var profile = UserManager.getInstance().getProfileRef()
            profile.setName(he.HeDisplayUtil.urlDecode(name))
            profile.setHeadUrl(headUrl)
            context.onLoadingComplete(data)
        }
    }
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write data to the device.")
    }
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kProfileUpdate))
    self.request(kHttpEndPoints.updateProfile, table(
        [1, "name", name],
        [1, "headUrl", headUrl],
        [1, "snsPlatform", snsPlatform],
        [1, "snsName", snsName]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// ConfirmInvite
// 
ConfirmInvite = xClass("ConfirmInvite", HttpBase)
ConfirmInvite.prototype.load = function (inviteCode, beInviter, errorLevel) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("confirm invite fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("confirm invite success")
            context.onLoadingComplete(data)
        }
    }
    var deviceUdid = he.MetaInfo.getInstance().getUdid()
    self.request(kHttpEndPoints.confirmInvite, table(
        [1, "inviteCode", inviteCode],
        [1, "beInviter", beInviter],
        [1, "errorLevel", errorLevel],
        [1, "deviceUdid", deviceUdid]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetInviteeReward for WanDouJia platform ---------------------------------------------------------
// 
GetInviteeRewardHttp = xClass("GetInviteeRewardHttp", HttpBase)
GetInviteeRewardHttp.prototype.load = function (inviters) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    if (!inviters || type(inviters) !== "table") {
        return
    }
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetInviteeReward error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetInviteeReward success !")
            self.onLoadingComplete(data)
        }
    }
    var params = table([1, "inviters", inviters])
    if (__ANDROID && _G.sns_token) {
        params.snsPlatform = PlatformConfig.getPlatformAuthName()
    }
    self.transponder.call(kHttpEndPoints.getInviteeReward, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// InviteFriendsHttp ---------------------------------------------------------
// 
InviteFriendsHttp = xClass("InviteFriendsHttp", HttpBase)
InviteFriendsHttp.prototype.load = function (uids) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    if (!uids || type(uids) !== "table") {
        return
    }
    cc.log("InviteFriendsHttp:uids=" + table.tostring(uids))
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("InviteFriends error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("InviteFriends success !")
            self.onLoadingComplete(data)
        }
    }
    var params = table()
    if (__IOS_FB) { // snsIds<string>
        params.snsIds = uids
    } else {
        params.friendUids = uids
    }
    self.transponder.call(kHttpEndPoints.inviteFriends, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// SendFreegift ---------------------------------------------------------
// 
SendFreegiftHttp = xClass("SendFreegiftHttp", HttpBase)
SendFreegiftHttp.prototype.load = function (sendType, messageId, targetUids, itemId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("SendFreegiftHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("SendFreegiftHttp success !")
            if (sendType === 2 && !__IOS_FB) { // facebook不送免费礼�?
                var tab = UserManager.getInstance().getWantIds()
                if ($len(tab) < 1) {
                    UserManager.getInstance().addUserPropNumber(10013, 1)
                }
            }
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    var sendee = table(
        [1, "messageId", messageId],
        [1, "receiverUids", targetUids],
        [1, "itemId", itemId]
    )
    sendee.type = sendType
    self.transponder.call(kHttpEndPoints.sendFreegift, sendee, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// AcceptFreegift
// 
AcceptFreegiftHttp = xClass("AcceptFreegiftHttp", HttpBase)
AcceptFreegiftHttp.prototype.load = function (messageId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("accept freegift fail, err: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.acceptFreegift, table([1, "id", messageId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// SendMsg --------------------------------------------
SendMsgHttp = xClass("SendMsgHttp", HttpBase)
SendMsgHttp.prototype.load = function (type, uids, genericId) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("SendMsgHttp error: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.sendMsg, table(
        [1, "type", type],
        [1, "receiverUids", $tableToArray(uids)],
        [1, "genericId", genericId]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// ProcessMsg --------------------------------------------
ProcessMsgHttp = xClass("ProcessMsgHttp", HttpBase)
ProcessMsgHttp.prototype.load = function (msgIds, action, category, all) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ProcessMsgHttp error: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.processMsg, table(
        [1, "msgIds", $tableToArray(msgIds)],
        [1, "action", action],
        [1, "category", category],
        [1, "all", all]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// AnimalInviteHttp --------------------------------------------
AnimalInviteHttp = xClass("AnimalInviteHttp", HttpBase)
AnimalInviteHttp.prototype.load = function (animalUids) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AnimalInviteHttp error: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.animalInvite, table([1, "animalUids", animalUids]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetExchangeCodeReward---------------------------------------------------------
// 
GetExchangeCodeRewardHttp = xClass("GetExchangeCodeRewardHttp", HttpBase)
GetExchangeCodeRewardHttp.prototype.load = function (code) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("IgnoreFreegiftHttp error: " + err)
            context.onLoadingError(err)
        } else {
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    var deviceType = he.MetaInfo.getInstance().getMachineType() || ""
    self.request(kHttpEndPoints.getExchangeCodeReward, table([1, "exchangeCode", code], [1, "deviceType", deviceType]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// PickFruitHttp ---------------------------------------------------------
PickFruitHttp = xClass("PickFruitHttp", HttpBase)
PickFruitHttp.prototype.load = function (id, mType) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("PickFruitHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("PickFruitHttp success !")
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.pickFruit, table([1, "id", id], [1, "type", mType]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetCompenRewardHttp ----------------------------------------------------
// 
GetCompenRewardHttp = xClass("GetCompenRewardHttp", HttpBase)
GetCompenRewardHttp.prototype.load = function (index) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetCompenRewardHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetCompenRewardHttp success !")
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    var device = "unknown"
    if (__IOS) {
        device = "ios"
    } else if (__ANDROID) {
        device = "android"
    } 
    self.request(kHttpEndPoints.getCompenReward, table([1, "compenId", index], [1, "deviceOS", device]), loadCallback, rpc.SendingPriority.kHigh, false)
}
DoOrderHttp = xClass("DoOrderHttp", HttpBase)
DoOrderHttp.prototype.load = function (tradeId, goodsId, num, totalFee, checkStr) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DoOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DoOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.doPaymentOrder, table(
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "num", num],
        [1, "totalFee", Math.round(totalFee)],
        [1, "checkStr", checkStr]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
DoWXOrderHttp = xClass("DoWXOrderHttp", HttpBase)
DoWXOrderHttp.prototype.load = function (platform, sign, tradeId, goodsId, goodsType, amount, goodsName, totalFee, ip) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DoWXOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DoWXOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.doWXPaymentOrder, table(
        [1, "platform", platform],
        [1, "checkStr", sign],
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "goodsType", goodsType],
        [1, "num", amount],
        [1, "goodsName", goodsName],
        [1, "totalFee", Math.round(totalFee)],
        [1, "ip", ip]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
DoWXOrderV2Http = xClass("DoWXOrderV2Http", HttpBase)
DoWXOrderV2Http.prototype.load = function (platform, sign, tradeId, goodsId, goodsType, amount, goodsName, totalFee, ip) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DoWXOrderV2Http error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DoWXOrderV2Http success !")
            context.onLoadingComplete(data)
        }
    }
    var wxPayAppId = GameProxy.getInstance().getWeChatPayAppId()
    self.transponder.call(kHttpEndPoints.doWXPaymentOrderV2, table(
        [1, "platform", platform],
        [1, "checkStr", sign],
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "goodsType", goodsType],
        [1, "num", amount],
        [1, "goodsName", goodsName],
        [1, "totalFee", Math.round(totalFee)],
        [1, "ip", ip],
        [1, "appId", wxPayAppId]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
DoAliOrderHttp = xClass("DoAliOrderHttp", HttpBase)
DoAliOrderHttp.prototype.load = function (platform, sign, tradeId, goodsId, goodsType, amount, goodsName, totalFee, signString) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DoAliOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DoAliOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.doAliPaymentOrder, table(
        [1, "platform", platform],
        [1, "checkStr", sign],
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "goodsType", goodsType],
        [1, "num", amount],
        [1, "goodsName", goodsName],
        [1, "totalFee", totalFee],
        [1, "signString", signString]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
DoHuaweiOrderHttp = xClass("DoHuaweiOrderHttp", HttpBase)
DoHuaweiOrderHttp.prototype.load = function (platform, sign, tradeId, goodsId, goodsType, amount, goodsName, totalFee) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DoHuaweiOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DoHuaweiOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.doHuaweiPaymentOrder, table(
        [1, "platform", platform],
        [1, "checkStr", sign],
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "goodsType", goodsType],
        [1, "num", amount],
        [1, "goodsName", goodsName],
        [1, "totalFee", Math.round(totalFee)]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
DoVivoOrderHttp = xClass("DoVivoOrderHttp", HttpBase)
DoVivoOrderHttp.prototype.load = function (platform, sign, tradeId, goodsId, goodsType, amount, goodsName, totalFee) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DoVivoOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DoVivoOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.doVivoPaymentOrder, table(
        [1, "platform", platform],
        [1, "checkStr", sign],
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "goodsType", goodsType],
        [1, "num", amount],
        [1, "goodsName", goodsName],
        [1, "totalFee", Math.round(totalFee)]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetRewardsHttp = xClass("GetRewardsHttp", HttpBase)
GetRewardsHttp.prototype.load = function (rewardId) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetRewardsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetRewardsHttp success !")
            cc.log(table.tostring(data))
            var ret = table()
            if (type(data.rewardItems) === "table") {
                for (var k = 1, v = data.rewardItems[1]; v; k++ , v = data.rewardItems[k]) {
                    if (type(v.itemId) === "number" && type(v.num) === "number") {
                        table.insert(ret, v)
                        UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.BETA_GIFT)
                    }
                }
            }
            data.rewardItems = ret
            UserManager.getInstance().setUserRewardBit(rewardId, true)
            UserManager.getInstance().flushUserData()
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getRewards, table([1, "rewardId", rewardId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
WXShareHttp = xClass("WXShareHttp", HttpBase)
WXShareHttp.prototype.load = function (uiType, turntableIndex) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WXShareHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WXShareHttp success !")
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.wxShare, table([1, "uitype", uiType], [1, "turntable", turntableIndex]), loadCallback, rpc.SendingPriority.kHigh, false)
}
TurnTableHttp = xClass("TurnTableHttp", HttpBase)
TurnTableHttp.prototype.load = function (pTableId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("TurnTableHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("TurnTableHttp success !")
            if (NetworkConfig.writeLocalDataStorage) {
                Localhost.getInstance().flushCurrentUserData()
            } else {
                cc.log("Did not write user data to the device.")
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.turnTable, table([1, "tableId", pTableId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
PushNotifyHttp = xClass("PushNotifyHttp", HttpBase)
PushNotifyHttp.prototype.load = function (uidList, msg, typeId, extra, targetTime) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("PushNotifyHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("PushNotifyHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.pushNotify, table(
        [1, "uids", $tableToArray(uidList)],
        [1, "msg", msg],
        [1, "typeId", typeId],
        [1, "extra", extra],
        [1, "targetTime", targetTime]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
DeleteCashLogsHttp = xClass("DeleteCashLogsHttp", HttpBase)
DeleteCashLogsHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetCashLogsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetCashLogsHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.delCashLog, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
DisposeBindingHttp = xClass("DisposeBindingHttp", HttpBase)
DisposeBindingHttp.prototype.load = function (snsPlatforms) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call("disConnect", table([1, "snsPlatforms", snsPlatforms]), loadCallback, rpc.SendingPriority.kHigh, false)
}
ActivityRewardHttp = xClass("ActivityRewardHttp", HttpBase)
ActivityRewardHttp.prototype.load = function (activityId, rewardId) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ActivityRewardHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ActivityRewardHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.activityReward, table(
        [1, "actId", activityId],
        [1, "rewardId", rewardId],
        [1, "requestTime", Localhost.time()]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetStarRewardOnlineHttp ---------------------------------------------------------
GetStarRewardOnlineHttp = xClass("GetStarRewardOnlineHttp", HttpBase)
GetStarRewardOnlineHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var id = data.starRewardId
    data.requestTime = Localhost.time()
    var loadCallback = function (endpoint, data, err) {
        cc.log(table.tostring(data), table.tostring(err), "???")
        if (err) {
            he_log_info("mark fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("mark success")
            if (type(data) === "table") {
                if (data.code === 0) { } else {
                    context.onLoadingError(data.code)
                    return
                }
            }
            if (type(data) === "table" && type(data.rewardItems) === "table") {
                for (var k1 in data.rewardItems) {
                    var v1 = data.rewardItems[k1]
                    var itemId = v1.itemId
                    var itemNumber = v1.num
                    UserProp.getInstance().rewardProp(itemId, itemNumber, null, null, ModuleName.STAR_TOTAL)
                }
            }
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getStarRewardsV2, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetStarRewardsConfigHttp ---------------------------------------------------------
GetStarRewardsConfigHttp = xClass("GetStarRewardsConfigHttp", HttpBase)
GetStarRewardsConfigHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get star config fail, err: " + err)
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getStarRewardsConfig, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetInviteFriendsReward ---------------------------------------------------------
GetInviteFriendsRewardV2 = xClass("GetInviteFriendsRewardV2", HttpBase)
GetInviteFriendsRewardV2.prototype.load = function (friendUid, rewardId) {
    var self = this
    var context = self
    var requestData = table([1, "friendUid", friendUid], [1, "rewardId", rewardId])
    requestData.requestTime = Localhost.time()
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("mark fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("mark success")
            if (type(data) === "table") {
                if (data.code === 0) { } else {
                    context.onLoadingError(data.code)
                    return
                }
            }
            if (type(data) === "table" && type(data.rewardItems) === "table") {
                for (var k1 in data.rewardItems) {
                    var v1 = data.rewardItems[k1]
                    var itemId = v1.itemId
                    var itemNumber = v1.num
                    UserProp.getInstance().rewardProp(itemId, itemNumber, null, null, ModuleName.FRIENDS_INVITE + "_" + (rewardId || ""))
                }
            }
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getInviteFriendsRewardV2, requestData, loadCallback, rpc.SendingPriority.kHigh, false)
}
UsePropsOnlineHttp = xClass("UsePropsOnlineHttp", HttpBase)
UsePropsOnlineHttp.prototype.load = function (itemType, levelId, param, itemList) {
    var self = this
    // body
    // if (itemList[1] === 10004) {
    //     self.onLoadingError("err")
    //     return
    // }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    var gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
    gameMode = gameMode || 0
    param = param || 0
    if (itemList.__isLuaTable) {
        itemList = $tableToArray(itemList)
    }
    var body = {
        "type": itemType,
        "levelId": levelId,
        "gameMode": gameMode,
        "param": param,
        "itemList": itemList,
        "requestTime": Localhost.time()
    }
    self.request(kHttpEndPoints.useProps, body, loadCallback, rpc.SendingPriority.kHigh, false)
}
// UsePropsHttp ---------------------------------------------------------
UsePropsHttp = UsePropsOnlineHttp
// UsePropsHttp = xClass("UsePropsHttp", HttpBase)
// UsePropsHttp.prototype.load = function (itemType, levelId, param, itemList) {
//     var self = this
//     function cacheHttp() {
//         var gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
//         gameMode = gameMode || 0
//         param = param || 0
//         var body = table(
//             [1, "type", itemType],
//             [1, "levelId", levelId],
//             [1, "gameMode", gameMode],
//             [1, "param", param],
//             [1, "itemList", itemList],
//             [1, "requestTime", Localhost.time()]
//         )
//         UserManager.getInstance().cacheHttp(kHttpEndPoints.useProps, body)
//         if (NetworkConfig.writeLocalDataStorage) {
//             Localhost.getInstance().flushCurrentUserData()
//         } else {
//             cc.log("Did not write user data to the device.")
//         }
//     }
//     //- 精力道具levelId�?0
//     if (levelId === 0) {
//         cacheHttp()
//         self.onLoadingComplete()
//     } else {
//         levelType = LevelType.getLevelTypeByLevelId(levelId)
//         if (levelType === GameLevelType.kEditor) {
//             self.onLoadingComplete()
//         } else {
//             cacheHttp()
//             self.onLoadingComplete()
//         }
//     }
// }

// PassLevelHttp ---------------------------------------------------------
PassLevelHttp = xClass("PassLevelHttp", HttpBase)
PassLevelHttp.calcSig = function (cacheHttp) {
    var params = table()
    params.levelId = cacheHttp.levelId
    params.score = cacheHttp.score
    params.star = cacheHttp.star
    params.targetCount = cacheHttp.targetCount || ""
    params.requestTime = cacheHttp.requestTime
    params.opLog = cacheHttp.opLog || ""
    params.bundle = cacheHttp.bundle
    params.curMd5 = cacheHttp.curMd5
    params.lvmd5 = cacheHttp.lvmd5
    params.idfa = cacheHttp.idfa || ""
    var paramKeys = table()
    for (var k in params) {
        var v = params[k]
        table.insert(paramKeys, k)
    }
    table.sort(paramKeys)
    var md5Src = ""
    for (var _ in paramKeys) {
        var v = paramKeys[_]
        md5Src = md5Src + tostring(params[v])
    }
    cc.log(md5Src)
    // FIXME: hecore
    // return he.HeMathUtils.ca(md5Src)
    return md5Src
}
PassLevelHttp.prototype.load = function (levelId, score, star, stageTime, coin, targetCount, opLog, gameLevelType, costMove, replay, otherData) {
    var self = this
 //   throw new Error("!!!!!")
    otherData = otherData || {}
    let context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("PassLevelHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("PassLevelHttp success !")
            context.onLoadingComplete(data)
        }
    }
    let data = {
        "levelId": levelId,
        "star": star,
        "score": score,
        "replay": replay,
        "targetCount": targetCount || 0,
        "newUnlock": true,
        "session": DCAssist.playLevelSession || 0
    }
    if (otherData.contestUid && otherData.formerScore) {
        data.contestUid = otherData.contestUid
        data.targetScore = otherData.formerScore
        data.targetDone = otherData.targetDone || false
        data.msgId = otherData.msgId || 0
    }
    if (LevelType.isMysteryIslandLevel(levelId)){
        data.targetDone = otherData.targetDone || false
    }
    //是否需要服务立即返回排名(引导需要) true:需要，false：不需要
    if(otherData.needRank) {
        data.needRank = otherData.needRank
    }
    // 广告刷新次数
    if (otherData.hasOwnProperty("refreshUseNum")) {
        data.refreshUseNum = otherData.refreshUseNum
    }
    // 增加了os字段
    cc.log("[结算] OnlineSetterHttp PassLevelHttp.load cc.sys.os ",cc.sys.os);
    if(cc.sys.os === cc.sys.OS_IOS){
        data.os = 2;
    }else if (cc.sys.os === cc.sys.OS_ANDROID){
        data.os = 1;
    }else{
        cc.log("[结算] OnlineSetterHttp PassLevelHttp.load 玩吧特殊处理");
        // let isQQIOS = require("clover/sns/SnsProxy").getInstance().isQQIOS()
        // if(isQQIOS){
        //     data.os = 2;
        // }else{
        //     data.os = 1;
        // }
        data.os = 1;
    }
    if(otherData.coastStarNum > 0) {
        data.coastStarNum = otherData.coastStarNum;
    }
    if (otherData.extra){
        data.extra = otherData.extra
    }
    if (otherData.effectCombineNum){
        data.effectCombineNum = otherData.effectCombineNum
    }
    if (otherData.dynamicGuideNum){
        data.dynamicGuideNum = otherData.dynamicGuideNum
    }
    if (otherData.src == "quit"){
        data.result = 3
    }else if (star > 0){
        data.result = 2
    }else if (star == 0){
        data.result = 1
    }
    
    cc.log("[Seaside]", "PassLevelHttpdata", data); 
    let levelVer = ResManager.getLevelMd5(levelId)
    if (levelId > LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START && levelId <= LevelConstans.MYSTERY_ISLAND_LEVEL_ID_END){
        let mysteryLv = tonumber(levelId || LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START) - LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START
        levelVer = ResManager.getLevelMd5(mysteryLv)
    }
    data.levelVer = levelVer
    // 
    if (LevelType.isMainLevel(levelId)){
        PromoteFlowManager.getInstance().addPlayNum();
    }
    self.request(kHttpEndPoints.passLevel, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

StartLevelHttp = xClass("StartLevelHttp", HttpBase)
StartLevelHttp.prototype.load = function (levelId, itemList, energyBuff, gameLevelType, otherData, adPropIds, energyFlag) {
    let context = this
    itemList = itemList || {}
    otherData = otherData || {}
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("StartLevelHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("StartLevelHttp success !")
            context.onLoadingComplete(data)
        }
    }
    let levelVer = ResManager.getLevelMd5(levelId)
    if (levelId > LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START && levelId <= LevelConstans.MYSTERY_ISLAND_LEVEL_ID_END){
        let mysteryLv = tonumber(levelId || LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START) - LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START
        levelVer = ResManager.getLevelMd5(mysteryLv)
    }
    if (energyFlag == null){
        energyFlag = 0
    }
    //console.log("[monthticket] energyFlag "+energyFlag)

    var gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
    gameMode = gameMode || 0
    let data = {
        levelId: levelId,
        needEnergy: 5,//NOTE:后端确认没用，暂时不修改
        energyFlag:energyFlag,
        itemList: $tableToArray(itemList),
        requestTime: Localhost.time(),
        gameMode: gameMode,
        param: 0,
        energyBuff: energyBuff,
        adItemList: adPropIds,
        levelVer: levelVer,
        levelList : [],
        session: DCAssist.playLevelSession || 0
    }

    //掉落优化v2
    let maxCount = 40
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    let curId = Math.max(0, topLevel - Math.floor(maxCount / 2)) + 1
    let count = 1
    while (count < maxCount && curId <= topLevel) {
        // if (self.checkExpireV2(curId)) {
            // table.insert(levels, curId)
            if (ResManager.getLevelMd5(curId)){
                data.levelList.push({
                    levelId: curId,
                    levelVer: ResManager.getLevelMd5(curId)
                })
            }
            count = count + 1
        // }
        curId = curId + 1
    }
    if (otherData.contestUid) {
        data.contestUid = otherData.contestUid
    }
    context.request(kHttpEndPoints.startLevel, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

LevelStuckHttp = xClass("LevelStuckHttp", HttpBase)
LevelStuckHttp.prototype.load = function (levelId, requestTime, session) {
    let context = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    let data = {
        levelId: levelId,
        requestTime: requestTime,
        session: session
    }
    context.request(kHttpEndPoints.levelStuck, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

AddFriendHttp = xClass("AddFriendHttp", HttpBase)
AddFriendHttp.prototype.load = function (inviteCode, beInviter) {
    let context = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    let data = {
        inviteCode: inviteCode,
        beInviter: beInviter
    }
    context.request(kHttpEndPoints.addFriend, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// SendGameBarMsgHttp ---------------------------------------------------------
SendGameBarMsgHttp = xClass("SendGameBarMsgHttp", HttpBase)
SendGameBarMsgHttp.prototype.load = function (data) {
    let context = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    context.request(kHttpEndPoints.sendGameBarMsg, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetWanbaGiftRewardsHttp ---------------------------------------------------------
GetWanbaGiftRewardsHttp = xClass("GetWanbaGiftRewards", HttpBase)
GetWanbaGiftRewardsHttp.prototype.load = function (data) {
    let context = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    context.request(kHttpEndPoints.getWanbaGiftRewards, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetNewUserRewardsHttp ---------------------------------------------------------
GetNewUserRewardsHttp = xClass("GetNewUserRewardsHttp", HttpBase)
GetNewUserRewardsHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetNewUserRewardsHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetNewUserRewardsHttp success !")
            self.onLoadingComplete()
        }
    }
    self.request(kHttpEndPoints.getNewUserRewards, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// GetSetShortcutRewardsHttp ---------------------------------------------------------
GetSetShortcutRewardsHttp = xClass("GetSetShortcutRewardsHttp", HttpBase)
GetSetShortcutRewardsHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetSetShortcutRewardsHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetSetShortcutRewardsHttp success !")
            self.onLoadingComplete()
        }
    }
    self.request(kHttpEndPoints.getShortcutRewards, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// FetchCoverRewardsHttp ---------------------------------------------------------
FetchCoverRewardsHttp = xClass("FetchCoverRewardsHttp", HttpBase)
FetchCoverRewardsHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("FetchCoverRewardsHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("FetchCoverRewardsHttp success !")
            self.onLoadingComplete()
        }
    }
    self.request(kHttpEndPoints.fetchCoverRewards, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// H5LoginHttp ---------------------------------------------------------
H5LoginHttp = xClass("H5LoginHttp", HttpBase)
H5LoginHttp.prototype.load = function (param) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("H5LoginHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("H5LoginHttp success !")
            self.onLoadingComplete(data)
        }
    }
    param.newUnlock = true;     //  老版本会自动解锁，所以要加个标记防止后端自动解锁
    self.request(ApiList.H5Login, param, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetDailyShareReward ---------------------------------------------------------
GetDailyShareReward = xClass("GetDailyShareReward", HttpBase)
GetDailyShareReward.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetDailyShareReward error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetDailyShareReward success !")
            self.onLoadingComplete(data)
        }
    }
    data = data ? data : table()
    self.request(kHttpEndPoints.getDailyShareReward, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// SendGift2StrangerHttp ---------------------------------------------------------
SendGift2StrangerHttp = xClass("SendGift2StrangerHttp", HttpBase)
SendGift2StrangerHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("SendGift2StrangerHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("SendGift2StrangerHttp success !")
            self.onLoadingComplete()
        }
    }
    self.request(kHttpEndPoints.sendGift2Stranger, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// ActiveHeadFrameHttp ---------------------------------------------------------
ActiveHeadFrameHttp = xClass("ActiveHeadFrameHttp", HttpBase)
ActiveHeadFrameHttp.prototype.load = function (targetId) {
    let self = this
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ActiveHeadFrameHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("ActiveHeadFrameHttp success !")
            self.onLoadingComplete(data)
        }
    }
    let data = {
        targetId : targetId,
        requestTime : Localhost.time()
    };
    self.request(kHttpEndPoints.activeHeadFrame, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// PublisherFetchRetCashHttp ---------------------------------------------------------
PublisherFetchRetCashHttp = xClass("PublisherFetchRetCashHttp", HttpBase)
PublisherFetchRetCashHttp.prototype.load = function (wId) {
    let self = this
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("PublisherFetchRetCashHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("PublisherFetchRetCashHttp success !")
            self.onLoadingComplete(data)
        }
    }
    let data = {
        orId : wId
    };
    self.request(kHttpEndPoints.publisherFetchRetCash, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// NewNameHttp ---------------------------------------------------------
NewNameHttp = xClass("NewNameHttp", HttpBase)
NewNameHttp.prototype.load = function (data) {
    var self = this
    var context = self
    data.requestTime = Localhost.time()
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("new name fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("new name success")
            var profile = UserManager.getInstance().getProfileRef()
            profile.setName(data.name)
            context.onLoadingComplete(data)
        }
    }
    var sendData = table.clone(data)
    sendData.name = he.HeDisplayUtil.urlEncode(sendData.name)
    self.request(kHttpEndPoints.newName, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// FetchLeadRewardsHttp ---------------------------------------------------------
FetchLeadRewardsHttp = xClass("FetchLeadRewardsHttp", HttpBase)
FetchLeadRewardsHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("FetchLeadRewardsHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("FetchLeadRewardsHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.fetchLeadRewards, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}

// 客服反馈 ---------------------------------------------------------
FcSubmitHttp = xClass("FcSubmitHttp", HttpBase)
FcSubmitHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("FcSubmitHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("FcSubmitHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.fcSubmit, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 微信小游戏群分享加五步 ---------------------------------------------------------
Add5StepWxGroupShare = xClass("Add5StepWxGroupShare", HttpBase)
Add5StepWxGroupShare.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("Add5StepWxGroupShare error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("Add5StepWxGroupShare success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.add5StepWxGroupShare, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 微信小游戏群分享加步数，轮询结果 ---------------------------------------------------------
AddStepWxGroupShare = xClass("AddStepWxGroupShare", HttpBase)
/**
 * @param data  包括shareId 分享编号、shareType 分享类型
 */
AddStepWxGroupShare.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AddStepWxGroupShare error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("AddStepWxGroupShare success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.addStepWxGroupShare, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 微信小游戏加步数链接被点击（目前仅金币大作战时候，后续欲全部统一到该接口）
AddStepWxGroupShareClickShare = xClass("AddStepWxGroupShareClickShare", HttpBase)
AddStepWxGroupShareClickShare.prototype.load = function (shareData) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AddStepWxGroupShareClickShare error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("AddStepWxGroupShareClickShare success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.addStepWxGroupShareClickShare, shareData, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 微信小游戏群分享精力瓶 ---------------------------------------------------------
AddEnergyWxGroupShare = xClass("AddEnergyWxGroupShare", HttpBase)
AddEnergyWxGroupShare.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AddEnergyWxGroupShare error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("AddEnergyWxGroupShare success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.addEnergyWxGroupShare, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

OpenChestHttp = xClass("OpenChestHttp", HttpBase)
OpenChestHttp.prototype.load = function (chestId) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("OpenChestHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("OpenChestHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.openChest, {chestId: chestId}, loadCallback, rpc.SendingPriority.kHigh, false)
}

GetChestRewardHttp = xClass("GetChestRewardHttp", HttpBase)
GetChestRewardHttp.prototype.load = function (chestId) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetChestRewardHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetChestRewardHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getChestReward, {chestId: chestId}, loadCallback, rpc.SendingPriority.kHigh, false)
}

OpenStarChestHttp = xClass("OpenStarChestHttp", HttpBase)
OpenStarChestHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("OpenStarChestHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("OpenStarChestHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.openStarChest, {}, loadCallback, rpc.SendingPriority.kHigh, false)
}

StealIsland = xClass("StealIsland", HttpBase)
StealIsland.prototype.load = function (friendId, islandId) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("StealIsland error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("StealIsland success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.islandSteal, {
        friendId: friendId, islandId: islandId
    }, loadCallback, rpc.SendingPriority.kHigh, false)
}

HelpFriendsIslandHttp = xClass("HelpFriendsIslandHttp", HttpBase)
HelpFriendsIslandHttp.prototype.load = function (friendId, islandId, isFromUrl = false) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("HelpFriendsIslandHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("HelpFriendsIslandHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.islandHelp, {
        friendId: friendId, islandId: islandId, fromUrl: isFromUrl
    }, loadCallback, rpc.SendingPriority.kHigh, false)
}

IslandGetRewardHttp = xClass("IslandGetRewardHttp", HttpBase)
IslandGetRewardHttp.prototype.load = function (islandId) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("IslandGetRewardHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("IslandGetRewardHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getIslandReward, { id: islandId }, loadCallback, rpc.SendingPriority.kHigh, false)
}

ClickShareIdHttp = xClass("ClickShareIdHttp", HttpBase)
ClickShareIdHttp.prototype.load = function (inviteCode, shareId) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ClickShareIdHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("ClickShareIdHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.clickShareId, {
        inviteCode: inviteCode,
        shareId: shareId,
        video: true
    }, loadCallback, rpc.SendingPriority.kHigh, false)
}

FetchAdRewardsHttp = xClass("FetchAdRewardsHttp", HttpBase)
FetchAdRewardsHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("FetchAdRewardsHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("FetchAdRewardsHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.fetchAdRewards, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

MarkPriseWxChestClickHttp = xClass("MarkPriseWxChestClickHttp", HttpBase)
MarkPriseWxChestClickHttp.prototype.load = function (inviteCode, linkCreateTime) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MarkPriseWxChestClickHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("MarkPriseWxChestClickHttp success !")
            self.onLoadingComplete(data)
        }
    }
    let data = {
        linkCreateTime: linkCreateTime,
        inviteCode: inviteCode
    }
    self.request(kHttpEndPoints.markPriseWxChestClick, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

MarkPriseWxChestHttp = xClass("MarkPriseWxChestHttp", HttpBase)
MarkPriseWxChestHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MarkPriseWxChestHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("MarkPriseWxChestHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.markPriseWxChest, null, loadCallback, rpc.SendingPriority.kHigh, false)
}

SetLevelStarHttp = xClass("SetLevelStarHttp", HttpBase)
SetLevelStarHttp.prototype.load = function (levelId, star, score) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MarkPriseWxChestHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("MarkPriseWxChestHttp success !")
            self.onLoadingComplete(data)
        }
    }
    let data = {
        "levelId":levelId,
        "star":star,
        "score":score
    }
    self.request(kHttpEndPoints.setLevelStar, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

AddStepByVideoHttp = xClass("AddStepByVideoHttp", HttpBase)
AddStepByVideoHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AddStepByVideoHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("AddStepByVideoHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.kAddStepVideo, null, loadCallback, rpc.SendingPriority.kHigh, false)
}

SaveDeviceSystemInfoHttp = xClass("SaveDeviceSystemInfoHttp", HttpBase)
SaveDeviceSystemInfoHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("SaveDeviceSystemInfoHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("SaveDeviceSystemInfoHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.saveDeviceSystemInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
OneStepHelpAddTimesHttp = xClass("OneStepHelpAddTimesHttp", HttpBase)
OneStepHelpAddTimesHttp.prototype.load = function (uid, shareId) {
    var self = this
    let data = {
        uid: uid,
        shareId: shareId
    }
    self.request(kHttpEndPoints.oneStepHelpAddTimes, data, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
OneStepRewardHttp = xClass("OneStepRewardHttp", HttpBase)
OneStepRewardHttp.prototype.load = function (opLog) {
    var self = this
    let data = {
        opLog: opLog
    }
    self.request(kHttpEndPoints.oneStepGetReward, data, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
OneStepStartLevelHttp = xClass("OneStepStartLevelHttp", HttpBase)
OneStepStartLevelHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.oneStepStartLevel, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

TimeModeHelpAddTimesHttp = xClass("TimeModeHelpAddTimesHttp", HttpBase)
TimeModeHelpAddTimesHttp.prototype.load = function (uid, shareId) {
    var self = this
    let data = {
        uid: uid,
        shareId: shareId
    }
    self.request(kHttpEndPoints.timeModeHelpAddTimes, data, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
TimeModeRewardHttp = xClass("TimeModeRewardHttp", HttpBase)
TimeModeRewardHttp.prototype.load = function (targetCount) {
    var self = this
    let data = {
        targetCount: targetCount
    }
    self.request(kHttpEndPoints.timeModeGetReward, data, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
TimeModeStartLevelHttp = xClass("TimeModeStartLevelHttp", HttpBase)
TimeModeStartLevelHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.timeModeStartLevel, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
CoinMatchActivityResetHttp = xClass("CoinMatchActivityResetHttp", HttpBase)
CoinMatchActivityResetHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.coinMatchActivityReset, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
CoinMatchHelpAddTimesHttp = xClass("CoinMatchHelpAddTimesHttp", HttpBase)
CoinMatchHelpAddTimesHttp.prototype.load = function (uid) {
    var self = this
    self.request(kHttpEndPoints.coinMatchHelpAddTimes, {
        uid: uid
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
CoinMatchPassLevelHttp = xClass("CoinMatchPassLevelHttp", HttpBase)
CoinMatchPassLevelHttp.prototype.load = function (steps, levelId, isWin, passTime) {
    var self = this
    self.request(kHttpEndPoints.coinMatchPassLevel, {
        costStep: steps,
        levelId: levelId,
        passLevel: isWin,
        passTime: passTime,
        ver: 1
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
CoinMatchGetRewardHttp = xClass("CoinMatchGetRewardHttp", HttpBase)
CoinMatchGetRewardHttp.prototype.load = function (type, index = 0) {
    var self = this
    self.request(kHttpEndPoints.coinMatchGetReward, {
        type: type,
        index: index
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
CoinMatchWatchAdHttp = xClass("CoinMatchWatchAdHttp", HttpBase)
CoinMatchWatchAdHttp.prototype.load = function (type) {
    var self = this
    self.request(
        kHttpEndPoints.coinMatchGetStepWatchAd, 
        { type: type },
        buildCallback(self), 
        rpc.SendingPriority.kHigh, false);
}

WxYiYuanGiftShareInHttp = xClass("WxYiYuanGiftShareInHttp", HttpBase)
WxYiYuanGiftShareInHttp.prototype.load = function (inviteCode) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WxYiYuanGiftShareInHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("WxYiYuanGiftShareInHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wxYiYuanGiftShareIn, {
        inviteCode: inviteCode,
    }, loadCallback, rpc.SendingPriority.kHigh, false)
}
WxYiYuanGiftRewardHttp = xClass("WxYiYuanGiftRewardHttp", HttpBase)
WxYiYuanGiftRewardHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WxYiYuanGiftRewardHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("WxYiYuanGiftRewardHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.fetchWxYiYuanGift, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
GoldMatchHelpAddTimesHttp = xClass("GoldMatchHelpAddTimesHttp", HttpBase)
GoldMatchHelpAddTimesHttp.prototype.load = function (inviteCode) {
    var self = this
    self.request(kHttpEndPoints.goldMatchHelpAddTimes, {
        inviteCode: inviteCode
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
GoldMatchStartLevelHttp = xClass("GoldMatchStartLevelHttp", HttpBase)
GoldMatchStartLevelHttp.prototype.load = function (levelId) {
    var self = this
    self.request(kHttpEndPoints.goldMatchStartLevel, {
        levelId: levelId
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
GoldMatchGetRewardHttp = xClass("GoldMatchGetRewardHttp", HttpBase)
GoldMatchGetRewardHttp.prototype.load = function (targetCount, time) {
    var self = this
    self.request(kHttpEndPoints.goldMatchGetReward, {
        targetCount: targetCount,
        time: time
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

GoldMatchAddStepByVideoHttp = xClass("GoldMatchAddStepByVideoHttp", HttpBase)
GoldMatchAddStepByVideoHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GoldMatchAddStepByVideoHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GoldMatchAddStepByVideoHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.goldMatchWatchAd, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
GoldMatchShareClickHttp = xClass("GoldMatchShareClickHttp", HttpBase)
GoldMatchShareClickHttp.prototype.load = function (uid, inviteCode, shareId) {
    var self = this
    self.request(kHttpEndPoints.goldMatchShareClick, {
        uid: uid,
        inviteCode: inviteCode,
        shareId: shareId
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
ClientConfigHttp = xClass("ClientConfigHttp", HttpBase)
ClientConfigHttp.prototype.load = function () {
    var self = this
    let config = GameSpeedManager.getInstance().getSpeedConfig()
    // 加上动画性能的设置
    let model = "unknow"
    if (cc.sys.platform === cc.sys.WECHAT_GAME) {
        model = mini.getSystemInfoSync().model
    }
    if (_G.__level_effect == "LOW"){
        config["GameEffectLevelLow"] = {[model]:1}
    }else{
        config["GameEffectLevelLow"] = {[model]:0}
    }
    config["ttSmallAmountUseDiamondV2"] = {value:UserManager.getInstance().getTTSmallAmountUseDiamond()}
    self.request(kHttpEndPoints.updateUserSetting, {
        gameClientSetting: config
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
/**
 * 限时挑战分享成功
 */
TimeModeShareSuccHttp = xClass("TimeModeShareSuccHttp", HttpBase)
TimeModeShareSuccHttp.prototype.load = function (uid) {
    var self = this
    self.request(kHttpEndPoints.timeModeShareSucc, {
        uid: uid,
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
/**
 * 攻略看广告接口
 */
LevelStrategyWatchAdHttp = xClass("LevelStrategyWatchAdHttp", HttpBase)
LevelStrategyWatchAdHttp.prototype.load = function (uid, levelId) {
    var self = this
    self.request(kHttpEndPoints.levelStrategyWatchAd, {
        uid: uid,
        levelId,
        version: ResManager.getLevelMd5(levelId) + (DAManager.getInstance().useV2() ? "new" : "")
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
/**
 * 攻略上传接口
 */
WriteStrategyReplayHttp = xClass("WriteStrategyReplayHttp", HttpBase)
WriteStrategyReplayHttp.prototype.load = function (uid, content, levelId) {
    var self = this
    self.request(kHttpEndPoints.writeStrategyReplay, {
        uid: uid,
        content: content,
        version: ResManager.getLevelMd5(levelId) + (DAManager.getInstance().useV2() ? "new" : "")
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
/**
 * 分享攻略享接口
 */
LevelStrategyShareHttp = xClass("LevelStrategyShareHttp", HttpBase)
LevelStrategyShareHttp.prototype.load = function (uid, strategyId, levelId) {
    var self = this
    self.request(kHttpEndPoints.levelStrategyShare, {
        uid: uid,
        version: ResManager.getLevelMd5(levelId) + (DAManager.getInstance().useV2() ? "new" : "")
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
// 宝箱额外奖励点击链接进入
StarChestExtraRewardShareInHttp = xClass("StarChestExtraRewardShareInHttp", HttpBase)
StarChestExtraRewardShareInHttp.prototype.load = function (askerUid, shareId) {
    this.request(kHttpEndPoints.starChestExtraRewardShareIn, 
        {askerUid:askerUid, shareId:shareId}, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 宝箱额外奖励分享成功回调
StarChestExtraRewardShareSuccHttp = xClass("StarChestExtraRewardShareSuccHttp", HttpBase)
StarChestExtraRewardShareSuccHttp.prototype.load = function (askerUid, shareId) {
    this.request(kHttpEndPoints.starChestExtraRewardShareSucc, 
        null, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 购买关前道具
StartPanelBuyPropHttp = xClass("StartPanelBuyPropHttp", HttpBase)
StartPanelBuyPropHttp.prototype.load = function (itemId, num) {
    var self = this
    assert(itemId != null, "itemId type is int")
    assert(num != null, "num type is int")
    function loadCallback(endpoint, data, err) {
        // body
        if (err) {
            self.onLoadingError(err)
        } else {
            let ret_data = table(
                [1, "goodsId", itemId],
                [1, "num", num],
                //[1, "moneyType", moneyType],
                //[1, "targetId", targetId],
                [1, "requestTime", Localhost.time()],
                [1, "buyResultInfo", data.buyResultInfo || ""]
            );
            self.onLoadingComplete(ret_data)
        }
    }

    let data = {
        "itemId": itemId,
        "num": num,
        "requestTime": Localhost.time(),
        "ad": false
    };
    self.request(kHttpEndPoints.propsBeforeLevelBuy, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 银币不足看广告获取
AddCoinByVideoHttp = xClass("AddCoinByVideoHttp", HttpBase)
AddCoinByVideoHttp.prototype.load = function () {
    this.request(kHttpEndPoints.addCoinByVideo, {}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 玩家帮助点击银币分享链接
AddCoinClickShareInHttp = xClass("AddCoinClickShareInHttp", HttpBase)
AddCoinClickShareInHttp.prototype.load = function (askerUid, shareId) {
    var data = {
        askerUid : askerUid,
        shareId : shareId
    }
    this.request(kHttpEndPoints.addCoinClickShareIn, data, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 小游戏授权接口
 */
AuthorizeHttp = xClass("AuthorizeHttp", HttpBase)
AuthorizeHttp.prototype.load = function (data) {
    let self = this
    self.request(kHttpEndPoints.authorize, data, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
// 失败分享后关闭界面用
AddStepWxGroupShareCloseHttp = xClass("AddStepWxGroupShareCloseHttp", HttpBase)
AddStepWxGroupShareCloseHttp.prototype.load = function (shareType, data) {
    var data = {
        shareType : shareType,
        data : data || ""
    }
    this.request(kHttpEndPoints.addStepWxGroupShareClose, data, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 主线关卡分享成功出现
PassLevelShowOffSuccHttp = xClass("PassLevelShowOffSuccHttp", HttpBase)
PassLevelShowOffSuccHttp.prototype.load = function (uid, trueFlag) {
    this.request(kHttpEndPoints.passLevelShowOffSucc, 
        {
            uid: uid,
            trueFlag: trueFlag
        }, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 百度2019活动上报积分
BaiduGameReportHttp = xClass("BaiduGameReportHttp", HttpBase)
/**
 * 编码Content-Token
 */
BaiduGameReportHttp.prototype.encodeContentToken = function (data) {
    let splits = ['w','x','y','z','A','B','C','D']
    let nextSplit = function () {
        return splits[Math.floor( Math.random() * splits.length )]
    }
    let reverseStr = function (str) {
        return (str === '') ? '' : reverseStr(str.substr(1)) + str.charAt(0);
    }
    let md5 = require("clover/utils/md5")
    let sumHash = md5(data.sum.toString(32))
    let token = sumHash
    let arr = data.elist
    for (let i = 0; i < arr.length; i++) {
        let result = arr[i].toString(32)
        token += nextSplit() + result
    }
    token += nextSplit() +  md5(token)
    return reverseStr(token) + "="
}

/**
 * 解码Content-Token
 */
BaiduGameReportHttp.prototype.decodeContentToken = function (str) {
    let reverseStr = function (str) {
        return (str === '') ? '' : reverseStr(str.substr(1)) + str.charAt(0);
    }
    let a = reverseStr(str.substr(0,str.length - 1)).split(/[wxyzABCD]/g)
    let sumHash = a.shift()
    let dataHash = a.pop()
    let r = []
    for (let i = 0; i < a.length; i++) {
        r.push(Number.parseInt(a[i], 32));
    }
    return { elist: r }
}


BaiduGameReportHttp.prototype.load = function (levelId, zid, token, scene, gameScore, swanId, startTime, endTime, stableScoreData) {
    this.headers = {"Content-Token": this.encodeContentToken(stableScoreData) }
    this.request(kHttpEndPoints.baiduGameReport, 
        {
            zid: zid,
            token: token,
            scene: scene,
            gameScore: gameScore,
            levelId:levelId,
            swanId: swanId,
            startTime: startTime,
            endTime: endTime,
            gameData: stableScoreData.rlist,
            online: true               
        }, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 获取关末礼包信息发送回执
 */
LevelEndGiftbagShowHttp = xClass("LevelEndGiftbagShowHttp", HttpBase)
LevelEndGiftbagShowHttp.prototype.load = function (giftBagId) {
    this.request(kHttpEndPoints.levelEndGiftbagShow, {giftBagId: giftBagId}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 获取关末礼包奖励
 */
LevelEndGiftbagGetHttp = xClass("LevelEndGiftbagGetHttp", HttpBase)
LevelEndGiftbagGetHttp.prototype.load = function (giftBagId) {
    this.request(kHttpEndPoints.levelEndGiftbagGet, {giftBagId: giftBagId}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 关末礼包邀请回调
 */
LevelEndShareGiftClickHttp = xClass("LevelEndShareGiftClickHttp", HttpBase)
LevelEndShareGiftClickHttp.prototype.load = function (inviteCode, shareId) {
    this.request(kHttpEndPoints.levelEndShareGiftClick, {inviteCode: inviteCode, shareId: shareId}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 商店礼包信息发送回执
 */
MarketGiftbagShowHttp = xClass("MarketGiftbagShowHttp", HttpBase)
MarketGiftbagShowHttp.prototype.load = function (giftBagList) {
    this.request(kHttpEndPoints.marketGiftBagShow, { giftBagList: giftBagList}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}
/**
 * 获取百度最高分
 */
BaiduGameInfoHttp = xClass("BaiduGameInfoHttp", HttpBase)
BaiduGameInfoHttp.prototype.load = function () {
    this.request(kHttpEndPoints.baiduGameInfo, null, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

//  签到
MarkV3Http = xClass("MarkV3Http", HttpBase)
MarkV3Http.prototype.load = function (data) {
    this.request(kHttpEndPoints.markV3, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//获取屏蔽状态
IpRegionStatusHttp = xClass("IpRegionStatus", HttpBase)
IpRegionStatusHttp.prototype.load = function (data) {
    this.request(kHttpEndPoints.ipRegionStatus, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}
//记录屏蔽状态
SaveIpRegionStatusHttp = xClass("SaveIpRegionStatus", HttpBase)
SaveIpRegionStatusHttp.prototype.load = function (data) {
    this.request(kHttpEndPoints.saveIpRegionStatus, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}
//活动推广
prizePromotionHttp = xClass("prizePromotionHttp", HttpBase)
prizePromotionHttp.prototype.load = function (data) {
    let self = this
    self.request(kHttpEndPoints.prizePromotion, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// pvp消耗门票
PvpConsumeHttp = xClass("PvpConsumeHttp", HttpBase)
PvpConsumeHttp.prototype.load = function () {
    this.request(kHttpEndPoints.pvpConsume, 
        {}, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp领取战报奖励
GainReportRewardHttp = xClass("GainReportRewardHttp", HttpBase)
GainReportRewardHttp.prototype.load = function (reportId) {
    this.request(kHttpEndPoints.gainReportReward, 
        {
            reportId: reportId
        }, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp领取战报奖励
PvpResultHttp = xClass("PvpResultHttp", HttpBase)
PvpResultHttp.prototype.load = function (progress, levelScore, collect, collectMax, costTime, result, targetUid, levelId) {
    this.request(kHttpEndPoints.pvpResult, 
        {
            progress: progress,
            levelScore:levelScore,
            collect:collect,
            collectMax:collectMax,
            costTime:costTime,
            result:result,
            targetUid:targetUid,
            levelId:levelId
        }, 
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}
//订阅
subscribeMessageHttp = xClass("subscribeMessageHttp", HttpBase)
subscribeMessageHttp.prototype.load = function (data) {
    let self = this
    self.request(kHttpEndPoints.subscribeMessage, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//记录查看广告
SaveShowVideoHttp = xClass("SaveShowVideoHttp", HttpBase)
SaveShowVideoHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.saveShowVideo, 
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//记录插屏广告次数
SaveInterAdHttp = xClass("SaveInterAdHttp", HttpBase)
SaveInterAdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.saveInterAd, 
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 通知看广告成功
DoStarRewardAdHttp = xClass("DoStarRewardAdHttp", HttpBase)
DoStarRewardAdHttp.prototype.load = function (adType) {
    let self = this
    self.request(kHttpEndPoints.doStarRewardAd, 
        {
            adType: adType
        },
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 抽奖
DoStarRewardDrawHttp = xClass("DoStarRewardDrawHttp", HttpBase)
DoStarRewardDrawHttp.prototype.load = function (drawType,drawCount) {
    let self = this
    self.request(kHttpEndPoints.doStarRewardDraw, 
        {
            drawType,
            drawCount,
        },
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖刷新奖池分享成功
DoStarRewardShareHttp = xClass("DoStarRewardShareHttp", HttpBase)
DoStarRewardShareHttp.prototype.load = function (shareType) {
    let self = this
    self.request(kHttpEndPoints.doStarRewardShare, 
        {
            shareType: shareType
        },
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖大奖分享点击
DoStarRewardInviteHttp = xClass("DoStarRewardInviteHttp", HttpBase)
DoStarRewardInviteHttp.prototype.load = function (inviteUid, shareId) {
    let self = this
    self.request(kHttpEndPoints.doStarRewardInvite, 
        {
            inviteUid: inviteUid,
            shareId: shareId
        },
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//  获取主线关通关双倍奖励
GetLevelBonusRewardHttp = xClass("GetLevelBonusRewardHttp", HttpBase)
GetLevelBonusRewardHttp.prototype.load = function (data) {
    let self = this
    self.request(kHttpEndPoints.getLevelBonusReward, data, buildCallback(this), rpc.SendingPriority.kHigh, true);
}

//  获取主线关通关双倍奖励分享重定向
LevelBonusShareInHttp = xClass("LevelBonusShareInHttp", HttpBase)
LevelBonusShareInHttp.prototype.load = function (data) {
    let self = this
    self.request(kHttpEndPoints.levelBonusShareIn, data, buildCallback(this), rpc.SendingPriority.kHigh, true);
}

//////////////////// 新排行
//  获取新排行榜首页展示信息（全国榜和地区榜）
GetNewRankInfoHttp = xClass("GetNewRankInfoHttp", HttpBase)
GetNewRankInfoHttp.prototype.load = function (type, areaCode, version) {
    let self = this
    let param = {
        type,
        areaCode,
        version
    }
    self.request(kHttpEndPoints.getNewRankInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 获取新排行榜好友榜首页展示信息
GetFriendNewRankInfoHttp = xClass("GetFriendNewRankInfoHttp", HttpBase)
GetFriendNewRankInfoHttp.prototype.load = function (needAward, encryptedData, iv) {
    let self = this
    let param = {
        encryptedData,
        iv,
        needAward
    }
    self.request(kHttpEndPoints.getFriendNewRankInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取新排行榜数据（全国榜和地区榜）
GetNewRankListHttp = xClass("GetNewRankListHttp", HttpBase)
GetNewRankListHttp.prototype.load = function (type, areaCode, version) {
    let self = this
    let param = {
        type,
        areaCode,
        version
    }
    self.request(kHttpEndPoints.getNewRankList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取新排行榜好友榜数据
GetFriendNewRankListHttp = xClass("GetFriendNewRankListHttp", HttpBase)
GetFriendNewRankListHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.getFriendNewRankList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取用户新排行榜系统推荐好友
GetNewRankRecommendedFriendsHttp = xClass("GetNewRankRecommendedFriendsHttp", HttpBase)
GetNewRankRecommendedFriendsHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.getNewRankRecommendedFriends, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 加推荐好友
AddNewRankRecommendedFriendHttp = xClass("AddNewRankRecommendedFriendHttp", HttpBase)
AddNewRankRecommendedFriendHttp.prototype.load = function (friendUid) {
    let self = this
    let param = {
        friendUid
    }
    self.request(kHttpEndPoints.addNewRankRecommendedFriend, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//  领取新排行榜进度奖励
FetchNewRankProgressRewardHttp = xClass("FetchNewRankProgressRewardHttp", HttpBase)
FetchNewRankProgressRewardHttp.prototype.load = function (encryptedData = "", iv = "") {
    let self = this
    let param = {
        encryptedData,
        iv
    }
    self.request(kHttpEndPoints.fetchNewRankProgressReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 为排行榜收集玩家地区
GatherUserAreaCodeHttp = xClass("GatherUserAreaCodeHttp", HttpBase) 
GatherUserAreaCodeHttp.prototype.load = function(areaCode) {
    let self = this
    let param = {
        areaCode
    }
    self.request(kHttpEndPoints.gatherUserAreaCode, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 针对微信感兴趣好友，登录时发奖
FetchNewRankFriendRewardHttp = xClass("FetchNewRankFriendRewardHttp", HttpBase) 
FetchNewRankFriendRewardHttp.prototype.load = function() {
    let self = this
    self.request(kHttpEndPoints.fetchNewRankFriendReward, null, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 精力红包真实分享链接重定向
RedbagClickRealShareHttp = xClass("RedbagClickRealShareHttp", HttpBase) 
RedbagClickRealShareHttp.prototype.load = function(inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.redbagClickRealShare, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 岛屿解锁看广告加速
IslandUnlockAdTimeHttp = xClass("IslandUnlockAdTimeHttp", HttpBase) 
IslandUnlockAdTimeHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.islandUnlockAdTime, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 点击岛屿加速解锁分享链接
ClickIslandUnlockShareTimeHttp = xClass("ClickIslandUnlockShareTimeHttp", HttpBase) 
ClickIslandUnlockShareTimeHttp.prototype.load = function(inviteCode) {
    let self = this
    let param = {
        inviteCode: inviteCode
    }
    self.request(kHttpEndPoints.clickIslandUnlockShareTime, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 点击岛屿解锁好友帮助分享链接
IslandUnlockClickShareHttp = xClass("IslandUnlockClickShareHttp", HttpBase) 
IslandUnlockClickShareHttp.prototype.load = function(inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.islandUnlockClickShare, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 岛屿解锁
IslandUnlockHttp = xClass("IslandUnlockHttp", HttpBase) 
IslandUnlockHttp.prototype.load = function(unlockType) {
    let self = this
    let param = {
        unlockType : unlockType
    }
    self.request(kHttpEndPoints.islandUnlock, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 点击岛屿解锁成功后分享链接
IslandSuccClickShareHttp = xClass("IslandSuccClickShareHttp", HttpBase) 
IslandSuccClickShareHttp.prototype.load = function(inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.islandSuccClickShare, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


// 点击岛屿满星成功后分享链接
IslandFullClickShareHttp = xClass("IslandFullClickShareHttp", HttpBase) 
IslandFullClickShareHttp.prototype.load = function(inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.fullStarClickShare, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//广告优化一期领取广告奖励
FetchAdRewardHttp = xClass("FetchAdRewardHttp", HttpBase) 
FetchAdRewardHttp.prototype.load = function(type,requestTime) {
    let self = this
    let param = {
        type: type,
        requestTime: requestTime
    }
    self.request(kHttpEndPoints.fetchAdReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


ChooseUserLocationHttp = xClass("ChooseUserLocationHttp", HttpBase) 
ChooseUserLocationHttp.prototype.load = function(location) {
    let self = this
    let param = {
        location: location
    }
    self.request(kHttpEndPoints.chooseUserLocation, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


DeleteAccountHttp = xClass("DeleteAccountHttp", HttpBase) 
DeleteAccountHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.deleteAccount, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//广告任务完成接口
AdTaskFinishHttp = xClass("AdTaskFinishHttp", HttpBase) 
AdTaskFinishHttp.prototype.load = function(id) {
    let self = this
    let param = {
        id :id
    }
    self.request(kHttpEndPoints.finishAdTask, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MysteriousIslandRankHttp = xClass("MysteriousIslandRankHttp", HttpBase) 
MysteriousIslandRankHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.mysteriousIslandRank, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MysteriousIslandExhibitionHttp = xClass("MysteriousIslandExhibitionHttp", HttpBase) 
MysteriousIslandExhibitionHttp.prototype.load = function(targetUid) {
    let self = this
    let param = {
        targetUid: targetUid
    }
    self.request(kHttpEndPoints.mysteriousIslandExhibition, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MysteriousIslandLikeHttp = xClass("MysteriousIslandLikeHttp", HttpBase) 
MysteriousIslandLikeHttp.prototype.load = function(targetUid) {
    let self = this
    let param = {
        targetUid: targetUid
    }
    self.request(kHttpEndPoints.mysteriousIslandLike, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
WriteStartLevelReplayHttp = xClass("WriteStartLevelReplayHttp", HttpBase) 
WriteStartLevelReplayHttp.prototype.load = function(replay) {
    let self = this
    let param = {
        replay: replay
    }
    self.request(kHttpEndPoints.writeStartLevelReplay, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 更换装扮
ChangeDressHttp = xClass("ChangeDressHttp", HttpBase) 
ChangeDressHttp.prototype.load = function(id) {
    let self = this
    let param = {
        id: id
    }
    self.request(kHttpEndPoints.changeDress, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

StarRewardGuideHttp = xClass("StarRewardGuideHttp", HttpBase) 
StarRewardGuideHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.starRewardGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PvpGuideHttp = xClass("PvpGuideHttp", HttpBase) 
PvpGuideHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.pvpGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
